@switch (data.type) {
<!-- ═══════════════════════════════════════════════════════════════════════
  PHONE section
  ════════════════════════════════════════════════════════════════════════ -->
@case ('PHONE') {
<div>
  @for (contactNumber of contactNumbers; track contactNumber; let i = $index) {
  <div>
    <form [formGroup]="contactNumber">
      <ng-container>
        <div class="row d-flex align-items-center pb-2">
          <div
            class="col-md-auto justify-content-start size-30"
            style="padding-right: 0px"
          >
            <mat-form-field
              style="width: 100%; font-size: 14px; padding-right: 0px"
              appearance="fill"
            >
              <mat-label>{{
                'configuration-fields.set-contact-number.type' | translate
              }}</mat-label>
              <mat-select
                #contactNumberType
                formControlName="type"
                id="configuration_fields_sel_phone_type"
                data-testid="configuration_fields_sel_phone_type"
                hideSingleSelectionIndicator="true"
              >
                <mat-option
                  id="configuration_fields_sel_phone_type_{{
                    CONTACT_NUMBER_TYPES.MOBILE.toLowerCase()
                  }}"
                  attr.data-testid="configuration_fields_sel_phone_type_{{
                    CONTACT_NUMBER_TYPES.MOBILE.toLowerCase()
                  }}"
                  [value]="CONTACT_NUMBER_TYPES.MOBILE"
                  >{{
                    'configuration-fields.set-contact-number.contact-types.mobile'
                      | translate
                  }}</mat-option
                >
                <mat-option
                  id="configuration_fields_sel_phone_type_{{
                    CONTACT_NUMBER_TYPES.HOME.toLowerCase()
                  }}"
                  attr.data-testid="configuration_fields_sel_phone_type_{{
                    CONTACT_NUMBER_TYPES.HOME.toLowerCase()
                  }}"
                  [value]="CONTACT_NUMBER_TYPES.HOME"
                  >{{
                    'configuration-fields.set-contact-number.contact-types.home'
                      | translate
                  }}</mat-option
                >
              </mat-select>
              <mat-error>{{
                'configuration-fields.set-contact-number.type-error' | translate
              }}</mat-error>
            </mat-form-field>
          </div>
          <div
            class="col justify-content-end size-60"
            style="padding-right: 0px"
          >
            <el-phone-number-input
              class="w-100"
              dataTestId="configuration_fields_input_phone_no"
              [value]="contactNumber.get('phone_number')?.value"
              (onChange)="handleOnChangePhoneNumber($event, i)"
              [required]="true"
            ></el-phone-number-input>
          </div>
          @if (i === 0) {
          <div
            class="d-flex justify-content-center size-10;padding-right:10px"
            style="overflow: visible"
          >
            <button
              class="mb-2 center"
              mat-icon-button
              (click)="onAddPhoneNumber()"
              id="configuration_fields_btn_add_contact"
              data-testid="configuration_fields_btn_add_contact"
              [matTooltip]="
                'configuration-fields.set-contact-number.add-new-btn'
                  | translate
              "
              [disabled]="noOfFields === contactNumbers.length"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
          } @if (i !== 0) {
          <div
            class="d-flex justify-content-center size-10;padding-right:10px"
            style="overflow: visible"
          >
            <button
              class="mb-2 center"
              mat-icon-button
              (click)="onDeleteClicked(i)"
              id="configuration_fields_btn_delete_contact"
              data-testid="configuration_fields_btn_delete_contact"
              [matTooltip]="
                'configuration-fields.set-contact-number.delete-btn' | translate
              "
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          }
        </div>
      </ng-container>
    </form>
  </div>
  }
</div>
}
<!-- ═══════════════════════════════════════════════════════════════════════
      EMAIL section
      ════════════════════════════════════════════════════════════════════════ -->
@case ('EMAIL') {
<div>
  @for (contactEmail of contactEmails; track contactEmail; let i = $index) {
  <div>
    <form [formGroup]="contactEmail">
      <ng-container>
        <div class="row" style="overflow: visible">
          <div class="col-4">
            <mat-form-field
              style="width: 100%; font-size: 14px"
              appearance="fill"
            >
              <mat-label>{{
                'configuration-fields.set-emails.type' | translate
              }}</mat-label>
              <mat-select
                formControlName="type"
                id="contacts-type"
                hideSingleSelectionIndicator="true"
              >
                <mat-option [value]="CONTACT_EMAIL_TYPES.PERSONAL">{{
                  'configuration-fields.set-emails.contact-types.personal'
                    | translate
                }}</mat-option>
                <mat-option [value]="CONTACT_EMAIL_TYPES.WORK">{{
                  'configuration-fields.set-emails.contact-types.work'
                    | translate
                }}</mat-option>
                <mat-option [value]="CONTACT_EMAIL_TYPES.EDUCATIONAL">{{
                  'configuration-fields.set-emails.contact-types.educational'
                    | translate
                }}</mat-option>
              </mat-select>
              <mat-error>{{
                'configuration-fields.set-emails.error-messages.type-error'
                  | translate
              }}</mat-error>
            </mat-form-field>
          </div>
          <div class="col-7" style="margin-left: -15px">
            <mat-form-field
              appearance="fill"
              style="width: 100%; font-size: 14px"
            >
              <mat-label>{{
                'configuration-fields.set-emails.email' | translate
              }}</mat-label>
              <input
                matInput
                formControlName="email"
                required
                id="email"
                type="email"
                [placeholder]="
                  'identities.create-user.email-placeholder' | translate
                "
                email="true"
              />
              @if (contactEmail.get('email').hasError('email')) {
              <mat-error>
                {{
                  'configuration-fields.set-emails.error-messages.email-error'
                    | translate
                }}
              </mat-error>
              } @if (contactEmail.get('email').hasError('required')) {
              <mat-error>{{
                'configuration-fields.set-emails.error-messages.email-error'
                  | translate
              }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-1" style="padding-right: 20px">
            @if (i !== 0) {
            <button
              class="my-2 center"
              mat-icon-button
              [disabled]="
                contactEmail.controls.is_primary.value && this.isRequired
              "
              (click)="onEmailDeleteClicked(i)"
              [matTooltip]="
                'configuration-fields.set-emails.email-delete-btn' | translate
              "
            >
              <mat-icon>delete</mat-icon>
            </button>
            } @if (i === 0) {
            <button
              class="my-2 center"
              mat-icon-button
              (click)="addNewContactEmail()"
              [matTooltip]="
                'configuration-fields.set-emails.add-new-btn' | translate
              "
              [disabled]="noOfFields === contactEmails.length"
            >
              <mat-icon>add</mat-icon>
            </button>
            }
          </div>
        </div>
      </ng-container>
    </form>
  </div>
  }
</div>
}
<!-- ═══════════════════════════════════════════════════════════════════════
        ADDRESS section
        ════════════════════════════════════════════════════════════════════════ -->
@case ('ADDRESS') {
<div>
  @for (address of addresses; track address; let i = $index) {
  <form [formGroup]="address">
    <span formGroupName="address">
      <div class="row mt-3">
        <div class="col-11">
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>{{
              'configuration-fields.set-addresses.street-address' | translate
            }}</mat-label>
            <input matInput formControlName="line1" required id="lead-line1" />
            <mat-error>{{
              'configuration-fields.set-addresses.error-messages.line1-error'
                | translate
            }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col-1">
          @if (i !== 0) {
          <button
            class="my-2 center"
            mat-icon-button
            (click)="onAddressDeleteClicked(i)"
            [matTooltip]="
              'configuration-fields.set-emails.email-delete-btn' | translate
            "
          >
            <mat-icon>delete</mat-icon>
          </button>
          } @if (i === 0) {
          <button
            class="my-2 center"
            mat-icon-button
            (click)="addNewAddresses()"
            [matTooltip]="
              'configuration-fields.set-address.add-new-btn' | translate
            "
            [disabled]="noOfFields === addresses.length"
          >
            <mat-icon>add</mat-icon>
          </button>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 pr-md-1">
          <el-autocomplete
            [options]="countryListForDropDown"
            [multiSelect]="false"
            [hideTheAllOption]="true"
            [label]="'configuration-fields.set-addresses.country' | translate"
            appearance="fill"
            [required]="true"
            [selected]="address.controls.address.get('country').value"
            (itemsSelected)="updateCountryValues($event, i)"
          >
          </el-autocomplete>
        </div>
        <div class="col-12 col-md-6 pl-md-1">
          <el-autocomplete
            (focusin)="updateDropdownOnFocus('state', i)"
            [isFieldsLoading]="loadingStates"
            [options]="dropdownsList[i].statesListForDropdown"
            [multiSelect]="false"
            [hideTheAllOption]="true"
            [label]="'configuration-fields.set-addresses.state' | translate"
            appearance="fill"
            [required]="true"
            (itemsSelected)="updateStateValues($event, i)"
            [selected]="address.controls.address.get('state').value"
            [disabled]="!address.controls.address.get('country').value"
          >
          </el-autocomplete>
        </div>
      </div>
      <div class="row">
        <div class="col-1" style="padding-right: 0px">
          <mat-divider
            vertical
            style="height: 40px; margin-right: 20px; margin-top: -21px"
          ></mat-divider>
          <mat-divider style="width: 22px; margin-left: 23px"></mat-divider>
        </div>
        <div class="col-5" style="padding-right: 4px; padding-left: 0px">
          <el-autocomplete
            (focusin)="updateDropdownOnFocus('district', i)"
            [isFieldsLoading]="loadingDistricts"
            [options]="dropdownsList[i].districtsListForDropdown"
            [multiSelect]="false"
            [hideTheAllOption]="true"
            [label]="'configuration-fields.set-addresses.district' | translate"
            appearance="fill"
            [required]="true"
            (itemsSelected)="updateDistrictValues($event, i)"
            [selected]="address.controls.address.get('district').value"
            [disabled]="!address.controls.address.get('state').value"
          >
          </el-autocomplete>
        </div>
        <div
          class="cityDropDown col-4 d-flex justify-content-between"
          style="padding-left: 4px; padding-right: 0px"
        >
          <el-autocomplete
            style="width: 99.5%"
            (focusin)="updateDropdownOnFocus('city', i)"
            [isFieldsLoading]="loadingCities"
            [options]="dropdownsList[i].citiesListForDropdown"
            [multiSelect]="false"
            [hideTheAllOption]="true"
            [label]="'configuration-fields.set-addresses.city' | translate"
            appearance="fill"
            [required]="true"
            (itemsSelected)="updateCityValues($event, i)"
            [selected]="address.controls.address.get('city').value"
            [disabled]="!address.controls.address.get('district').value"
          >
          </el-autocomplete>
          <mat-divider vertical style="height: 58px"></mat-divider>
        </div>
        <div
          class="postalCodeField col-2"
          style="min-height: 58px !important; padding-left: 0px"
        >
          <mat-form-field
            appearance="fill"
            style="width: 100%; min-height: 74px !important"
          >
            <mat-label>{{
              'configuration-fields.set-addresses.postal-code' | translate
            }}</mat-label>
            <input
              [readonly]="
                dropdownsList[i].postalCodesListForDropdown?.length > 0 ||
                loadingPostalCodes
              "
              matInput
              formControlName="postal_code"
              id="postal_code"
            />
            <mat-error>
              {{
                'configuration-fields.set-addresses.error-messages.postal-code-error'
                  | translate
              }}</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </span>
  </form>
  }
</div>
}
<!-- ═══════════════════════════════════════════════════════════════════════
              NAME section
              ════════════════════════════════════════════════════════════════════════ -->
@case ('NAME') {
<div>
  <form [formGroup]="form">
    <div class="row mt-3">
      <div class="col">
        <div class="d-flex justify-content-between">
          <div class="row">
            <mat-form-field style="width: 93%" appearance="fill">
              <mat-label>{{
                'configuration-fields.set-name.salutation' | translate
              }}</mat-label>
              <mat-select
                [placeholder]="
                  'configuration-fields.set-name.salutation' | translate
                "
                formControlName="salutation"
                hideSingleSelectionIndicator="true"
              >
                @for (salutation of salutations; track salutation) {
                <mat-option [value]="salutation">{{ salutation }}</mat-option>
                }
              </mat-select>
              <mat-error style="white-space: nowrap; overflow: hidden">{{
                'configuration-fields.set-name.error-salutation' | translate
              }}</mat-error>
            </mat-form-field>
            <mat-divider vertical style="height: 53px"></mat-divider>
          </div>
          <mat-form-field style="width: 73%" appearance="fill">
            <mat-label>{{
              'configuration-fields.set-name.first-name' | translate
            }}</mat-label>
            <input
              id="first_name"
              type="text"
              matInput
              [placeholder]="
                'identities.create-user.first-name-placeholder' | translate
              "
              formControlName="first_name"
              pattern="^[A-Za-z]+$"
              required
            />
            @if (form.controls.first_name.hasError('required')) {
            <mat-error>{{
              'configuration-fields.set-name.required-error-first-name'
                | translate
            }}</mat-error>
            } @if (form.controls.first_name.hasError('pattern')) {
            <mat-error>
              {{
                'configuration-fields.set-name.pattern-error-first-name'
                  | translate
              }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="row">
          <div class="col-1" style="padding-right: 0px">
            <mat-divider
              vertical
              style="height: 40px; margin-right: 20px; margin-top: -21px"
            ></mat-divider>
            <mat-divider style="width: 34px; margin-left: 20px"></mat-divider>
          </div>
          <div class="col-5" style="padding-right: 4px">
            <mat-form-field style="width: 100%" appearance="fill">
              <mat-label>{{
                'configuration-fields.set-name.middle-name' | translate
              }}</mat-label>
              <input
                id="middle_name"
                type="text"
                matInput
                [placeholder]="
                  'identities.create-user.mid-name-placeholder' | translate
                "
                formControlName="middle_name"
                pattern="^[A-Za-z]+$"
              />
              @if (form.controls.middle_name.hasError('pattern')) {
              <mat-error>
                {{
                  'configuration-fields.set-name.pattern-error-middle-name'
                    | translate
                }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-6" style="padding-left: 4px">
            <mat-form-field style="width: 100%" appearance="fill">
              <mat-label>{{
                'configuration-fields.set-name.last-name' | translate
              }}</mat-label>
              <input
                id="last_name"
                type="text"
                matInput
                [placeholder]="
                  'identities.create-user.last-name-placeholder' | translate
                "
                formControlName="last_name"
                pattern="^[A-Za-z]+$"
              />
              @if (form.controls.last_name.hasError('required')) {
              <mat-error>{{
                'configuration-fields.set-name.required-error-last-name'
                  | translate
              }}</mat-error>
              } @if (form.controls.last_name.hasError('pattern')) {
              <mat-error>{{
                'configuration-fields.set-name.pattern-error-last-name'
                  | translate
              }}</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
} }
